import React, { Component } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, Space, Upload, Switch } from "antd";

class CustomDrawer extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }
  componentDidUpdate(prevProps) {
    if (this.props.openModal && !prevProps.openModal) {
      if (this.formRef.current) this.formRef.current.resetFields();
    }
  }
  render() {
    return (
      <Drawer
        title={this.props.isNewService ? "Crear servicio" : "Editar servicio"}
        width={720}
        onClose={() => this.props.handleCancelForm()}
        open={this.props.openModal}
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          hideRequiredMark
          initialValues={{
            title: this.props.service.title,
            id: this.props.service.id,
          }}
        >
          <Col span={24}>
            <Form.Item name="svg" label="Icono">
              <Upload>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="title"
              label="Titulo"
              hasFeedback
              validateStatus={this.props.formErrors.title ? "error" : ""}
              help={
                this.props.formErrors.title ? this.props.formErrors.title : ""
              }
            >
              <Input
                name="title"
                onChange={(event) => this.props.handleInputChange(event)}
                style={{ width: "100%" }}
                placeholder="Ingresar el título"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="id"
              label="ID"
              hasFeedback
              validateStatus={this.props.formErrors.id ? "error" : ""}
              help={this.props.formErrors.id ? this.props.formErrors.id : ""}
            >
              <Input
                name="id"
                onChange={(event) => this.props.handleInputChange(event)}
                style={{ width: "100%" }}
                placeholder="Ingresar un ID único"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="status" label="Estado">
              <Switch
                checked={this.props.service.status}
                onChange={(event) => this.props.handleInputChange(event)}
              />
            </Form.Item>
          </Col>
          <Space>
            <Button onClick={() => this.props.handleCancelForm()}>
              Cancelar
            </Button>
            <Button
              onClick={() =>
                this.props.isNewService
                  ? this.props.handleFormSubmit()
                  : this.props.handleEditForm()
              }
              type="primary"
              disabled={
                Object.keys(this.props.formErrors).length !== 0 ||
                this.props.service.title.length < 1
              }
            >
              {this.props.isNewService ? "Crear servicio" : "Editar servicio"}
            </Button>
          </Space>
        </Form>
      </Drawer>
    );
  }
}

export default CustomDrawer;



// WEBPACK FOOTER //
// ./src/views/Configurator/components/CustomDrawer.jsx